import React from 'react';
import {useStateValue} from './state';

function DebugPanel() {

    const [{connection}, ] = useStateValue();
    const [{operation}, ] = useStateValue();
    // const [{metadata}, ] = useStateValue();

    const debugTable = (<>

        <table className='dataTable'>
                            <tbody>
                                <tr className='attrTD'><td>Connection</td><td>{JSON.stringify(connection)}</td></tr>
                                <tr className='attrTD'><td>Operation</td><td>{JSON.stringify(operation)}</td></tr>
                                {/*<tr className='attrTD'><td>Metadata</td><td>{JSON.stringify(metadata.Table || 'none')}</td></tr>*/}

                            </tbody>
                        </table>
        </>
    );

    return debugTable;

}

export default DebugPanel;
